import { useNavigate } from "react-router-dom";
import { BoxFiltros, ClientesContainer } from "./styles";
import Table from "./Table";
import { useState } from "react";
import cliente from "../../assets/cliente.svg";
import { ReactSVG } from "react-svg";

const Clientes = () => {
  const navigate = useNavigate();
  const [perfilSelecionado, setPerfilSelecionado] = useState("");
  const [textoPesquisa, setTextoPesquisa] = useState("");

  function NovoCliente() {
    navigate("/cliente/novo");
  }
  return (
    <ClientesContainer>
      <div className="box">
        <div className="flex">
          <ReactSVG src={cliente} />
          <h1>Cliente</h1>
        </div>
        <BoxFiltros>
          <div className="filtro">
            <input
              placeholder="Pesquisar por ID ou Nome do cliente"
              value={textoPesquisa}
              onChange={(e) => setTextoPesquisa(e.target.value)}
            />
            <div>
              <p>Filtrar por status</p>
              <select
                value={perfilSelecionado}
                onChange={(e) => setPerfilSelecionado(e.target.value)}
              >
                <option value="">Ver todos</option>
                <option value={1}>ativo</option>
                <option value={0}>inativo</option>
              </select>
            </div>
          </div>
          <button onClick={NovoCliente}>Novo Cliente</button>
        </BoxFiltros>
        <Table
          perfilSelecionado={perfilSelecionado}
          textoPesquisa={textoPesquisa}
        />
      </div>
    </ClientesContainer>
  );
};

export default Clientes;
